import { createAsyncAction, createAction } from 'typesafe-actions';
import { AxiosError } from 'axios';
import { tabAIState, GET_PATH_NETWORK_RECOMMEND_INFO } from './types';
import { responseType } from '../../lib/tabAI/api';
import {
  GetPatentType,
  GetPatentParamType,
  GetRecommendedWordParamType,
  GetRecommendedWordType,
} from '../../lib/tabAI/type';
import {
  GetPathNetworkRecommendParamType2,
  GetPathNetworkRecommendType2,
} from '../../lib/tabAI/recommendType';

export const GET_PATH_NETWORK_RECOMMEND = 'tabAI/GET_PATH_NETWORK_RECOMMEND' as const;
export const GET_PATH_NETWORK_RECOMMEND_SUCCESS = 'tabAI/GET_PATH_NETWORK_RECOMMEND_SUCCESS' as const;
export const GET_PATH_NETWORK_RECOMMEND_ERROR = 'tabAI/GET_PATH_NETWORK_RECOMMEND_ERROR' as const;

export const GET_PATH_NETWORK_RECOMMEND2 = 'tabAI/GET_PATH_NETWORK_RECOMMEND2' as const;
export const GET_PATH_NETWORK_RECOMMEND2_SUCCESS = 'tabAI/GET_PATH_NETWORK_RECOMMEND2_SUCCESS' as const;
export const GET_PATH_NETWORK_RECOMMEND2_ERROR = 'tabAI/GET_PATH_NETWORK_RECOMMEND2_ERROR' as const;

export const GET_PATENT = 'tabAI/GET_PATENT' as const;
export const GET_PATENT_SUCCESS = 'tabAI/GET_PATENT_SUCCESS' as const;
export const GET_PATENT_ERROR = 'tabAI/GET_PATENT_ERROR' as const;

export const GET_RECOMMENDED_WORD = 'tabAI/GET_RECOMMENDED_WORD' as const;
export const GET_RECOMMENDED_WORD_SUCCESS = 'tabAI/GET_RECOMMENDED_WORD_SUCCESS' as const;
export const GET_RECOMMENDED_WORD_ERROR = 'tabAI/GET_RECOMMENDED_WORD_ERROR' as const;

export const SET_IS_MORE_INFO_PATH_0 = 'tabAI/SET_IS_MORE_INFO_PATH_0' as const;
export const SET_IS_MORE_INFO_PATH_1 = 'tabAI/SET_IS_MORE_INFO_PATH_1' as const;
export const SET_IS_MORE_INFO_PATH_2 = 'tabAI/SET_IS_MORE_INFO_PATH_2' as const;

export const SET_IS_MORE_INFO_PATH_ATTACH_0 = 'tabAI/SET_IS_MORE_INFO_PATH_ATTACH_0' as const;
export const SET_IS_MORE_INFO_PATH_ATTACH_1 = 'tabAI/SET_IS_MORE_INFO_PATH_ATTACH_1' as const;
export const SET_IS_MORE_INFO_PATH_ATTACH_2 = 'tabAI/SET_IS_MORE_INFO_PATH_ATTACH_2' as const;

export const SET_AI_DATA_NULL = 'tabAI/SET_AI_DATA_NULL' as const;

export const getPathNetworkRecommendAsync = createAsyncAction(
  GET_PATH_NETWORK_RECOMMEND,
  GET_PATH_NETWORK_RECOMMEND_SUCCESS,
  GET_PATH_NETWORK_RECOMMEND_ERROR
)<GET_PATH_NETWORK_RECOMMEND_INFO, responseType, AxiosError>();

export const getPathNetworkRecommend2Async = createAsyncAction(
  GET_PATH_NETWORK_RECOMMEND2,
  GET_PATH_NETWORK_RECOMMEND2_SUCCESS,
  GET_PATH_NETWORK_RECOMMEND2_ERROR
)<
  GetPathNetworkRecommendParamType2,
  GetPathNetworkRecommendType2,
  AxiosError
>();

export const getPatentAsync = createAsyncAction(
  GET_PATENT,
  GET_PATENT_SUCCESS,
  GET_PATENT_ERROR
)<GetPatentParamType, GetPatentType, AxiosError>();

export const getRecommendedWordAsync = createAsyncAction(
  GET_RECOMMENDED_WORD,
  GET_RECOMMENDED_WORD_SUCCESS,
  GET_RECOMMENDED_WORD_ERROR
)<GetRecommendedWordParamType, GetRecommendedWordType, AxiosError>();

export const setIsMoreInfoPath0 = createAction(
  SET_IS_MORE_INFO_PATH_0,
  (isMoreInfoPath0: tabAIState['isMoreInfoPath0']) => isMoreInfoPath0
)<tabAIState['isMoreInfoPath0']>();

export const setIsMoreInfoPath1 = createAction(
  SET_IS_MORE_INFO_PATH_1,
  (isMoreInfoPath1: tabAIState['isMoreInfoPath1']) => isMoreInfoPath1
)<tabAIState['isMoreInfoPath1']>();

export const setIsMoreInfoPath2 = createAction(
  SET_IS_MORE_INFO_PATH_2,
  (isMoreInfoPath2: tabAIState['isMoreInfoPath2']) => isMoreInfoPath2
)<tabAIState['isMoreInfoPath2']>();

export const setIsMoreInfoPathAttach0 = createAction(
  SET_IS_MORE_INFO_PATH_ATTACH_0,
  (isMoreInfoPathAttach0: tabAIState['isMoreInfoPathAttach0']) =>
    isMoreInfoPathAttach0
)<tabAIState['isMoreInfoPathAttach0']>();

export const setIsMoreInfoPathAttach1 = createAction(
  SET_IS_MORE_INFO_PATH_ATTACH_1,
  (isMoreInfoPathAttach1: tabAIState['isMoreInfoPathAttach1']) =>
    isMoreInfoPathAttach1
)<tabAIState['isMoreInfoPathAttach1']>();

export const setIsMoreInfoPathAttach2 = createAction(
  SET_IS_MORE_INFO_PATH_ATTACH_2,
  (isMoreInfoPathAttach2: tabAIState['isMoreInfoPathAttach2']) =>
    isMoreInfoPathAttach2
)<tabAIState['isMoreInfoPathAttach2']>();

export const setAIDataNull = createAction(SET_AI_DATA_NULL)();
